<template>
  <div>
    <v-btn-toggle class="d-flex flex-warp mt-2" v-model="selectedIndex" @change="fetchData()" borderless mandatory tile>
      <div style="width: 100%">
        <v-btn class="white--text" color="primary" width="50%" v-text="'sessions'" elevation="0" tile> </v-btn>
        <v-btn class="white--text" color="primary" width="50%" v-text="'units'" elevation="0" tile> </v-btn>
      </div>
    </v-btn-toggle>

    <v-list class="pa-0">
      <v-list-item class="pa-0" v-for="(data, i) in dataList" :key="data.id">
        <v-list-item-content :class="[i !== 0 ? 'border-top' : '', 'pa-0']">
          <session-card v-bind="data" :hasLink="false" v-if="typeSelected === 'sessionCalendar' && !loading">
            <template v-slot:action="{ content }">
              <div class="mt-2 float-right">
                <v-btn
                  color="error"
                  @click="removeToCalendar(data)"
                  class="ml-auto"
                  v-if="calendar.sessionCalendar.includes(data.id)"
                  icon
                >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
                <v-btn
                  color="success"
                  @click.stop="
                    addCalendarDialog = true;
                    calendarData = { ...data, ...content };
                  "
                  :disabled="calendar.sessionCalendar.includes(data.id)"
                  small
                >
                  Calendar Option
                  <v-icon size="15px" right>mdi-calendar</v-icon>
                </v-btn>
              </div>
            </template>
          </session-card>
          <unit-card v-bind="data" :hasLink="false" v-if="typeSelected === 'unitCalendar' && !loading">
            <template v-slot:action="{ content }">
              <div class="mt-2 float-right">
                <v-btn
                  color="error"
                  @click="removeToCalendar(data)"
                  class="ml-auto"
                  v-if="calendar.unitCalendar.includes(data.id)"
                  icon
                >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
                <v-btn
                  color="success"
                  @click.stop="
                    addCalendarDialog = true;
                    calendarData = { ...data, ...content };
                  "
                  :disabled="calendar.unitCalendar.includes(data.id)"
                  small
                >
                  Calendar Option
                  <v-icon size="15px" right>mdi-calendar</v-icon>
                </v-btn>
              </div>
            </template>
          </unit-card>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog v-model="addCalendarDialog">
      <v-card tile>
        <v-card-title class="pt-2 pb-1 text-body-1 primary white--text rounded-0">
          Calendar Option
        </v-card-title>

        <v-card-text class="pa-2">
          <v-btn
            color="success"
            @click.stop="
              addToCalendar(calendarData);
              addCalendarDialog = false;
            "
            small
            block
          >
            Add Calendar
            <v-icon size="15px" right>mdi-calendar</v-icon>
          </v-btn>
          <v-btn
            color="accent"
            @click.stop="
              downloadCalendar(calendarData);
              addCalendarDialog = false;
            "
            class="mt-2"
            small
            block
          >
            Download ICS
            <v-icon size="15px" right>mdi-download</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import apiSession from "@/apis/Session";
import apiUnit from "@/apis/Unit";
import SessionCard from "@/components/Card/Session";
import UnitCard from "@/components/Card/Unit";

import LocalStorage from "store2";

export default {
  name: "MySchedule",
  components: { SessionCard, UnitCard },
  data() {
    return {
      addCalendarDialog: false,
      calendarData: null,
      selectedIndex: 0,
      typeList: ["sessionCalendar", "unitCalendar"],
      dataList: [],
      calendar: {
        unitCalendar: [],
        sessionCalendar: []
      },
      loading: true
    };
  },
  computed: {
    typeSelected() {
      return this.typeList[this.selectedIndex];
    }
  },
  watch: {
    addCalendarDialog(val) {
      if (!val) this.calendarData = null;
    }
  },
  methods: {
    makeGoogleCalendarUrl({ title_en, location, start_time, end_time }) {
      const title = this.$store.state.conference.code + " : " + title_en;
      const place = this.$store.state.conference.location + ` ( ${location} )`;
      const begin = this.$dayjs(start_time)
        .subtract(8, "h")
        .format("YYYYMMDDTHHmmss");
      const stop = this.$dayjs(end_time)
        .subtract(8, "h")
        .format("YYYYMMDDTHHmmss");

      return `https://calendar.google.com/calendar/r/eventedit?text=${title}&dates=${begin}/${stop}&location=${place}`;
    },
    downloadCalendar({ id, title_en, location, start_time, end_time }) {
      const subject = this.$store.state.conference.code + " : " + title_en;
      const place = this.$store.state.conference.location + ` ( ${location} )`;
      const begin = this.$dayjs(start_time)
        .subtract(8, "h")
        .valueOf();
      const stop = this.$dayjs(end_time)
        .subtract(8, "h")
        .valueOf();

      this.$ics.removeAllEvents();
      this.$ics.addEvent("en-us", subject, "", place, begin, stop, "", {
        name: "TSVS",
        email: "4tsvs@tsvs.org"
      });
      this.$ics.download(subject);

      LocalStorage.add(this.typeSelected, id);
      this.calendar[this.typeSelected] = LocalStorage.get(this.typeSelected);
    },
    addToCalendar({ id, ...detail }) {
      window.open(this.makeGoogleCalendarUrl(detail));

      LocalStorage.add(this.typeSelected, id);
      this.calendar[this.typeSelected] = LocalStorage.get(this.typeSelected);
    },
    removeToCalendar({ id }) {
      const removeIndex = this.calendar[this.typeSelected].findIndex(item => item === id);

      this.calendar[this.typeSelected].splice(removeIndex, 1);
      LocalStorage.set(this.typeSelected, this.calendar[this.typeSelected]);
    },
    syncCalendar() {
      if (!LocalStorage.has("unitCalendar")) LocalStorage.set("unitCalendar", []);
      if (!LocalStorage.has("sessionCalendar")) LocalStorage.set("sessionCalendar", []);

      this.calendar.unitCalendar = LocalStorage.get("unitCalendar");
      this.calendar.sessionCalendar = LocalStorage.get("sessionCalendar");
    },
    async fetchData() {
      this.loading = true;

      const sortTime = (a, b) => {
        const timeStartA = this.$dayjs(a.start_time);
        const timeStartB = this.$dayjs(b.start_time);

        if (timeStartA.isBefore(timeStartB)) return -1;
        if (timeStartB.isBefore(timeStartA)) return 1;

        return 0;
      };

      let data = null;
      switch (this.typeSelected) {
        case "sessionCalendar":
          data = await this.getSessions();
          break;
        case "unitCalendar":
          data = await this.getUnits();
          break;
      }

      this.dataList = data.sort(sortTime);
      this.loading = false;
    },
    async getSessions() {
      return await apiSession.get();
    },
    async getUnits() {
      return await apiUnit.get();
    }
  },
  async mounted() {
    this.syncCalendar();
    await this.fetchData();
  }
};
</script>

<style></style>
